<div class="" [ngStyle]="(currentModule != 'personsearch') && {'border-radius': '8px' }" [ngClass]="{'wccard':calledFrom != 'mainscreen' || searchToolboxHistory?.length > 0, 'px-3 py-2': searchToolboxHistory?.length }" *ngIf="!openModal">
  <div class="d-flex justify-content-between" *ngIf="calledFrom != 'mainscreen'">
    <span class="f-12 font-weight-600"  *ngIf="!save && searchToolboxHistory?.length > 0 && calledForSaveSearch != 'saveSearch'">
      <i class="far fa-clock mr-1"></i>History
    </span>

    <span class="f-14 font-weight-600" *ngIf="save && searchToolboxHistory?.length > 0">
      <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
    </span>
     <span class="f-14 font-weight-600" *ngIf="calledForSaveSearch == 'saveSearch'">
      <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
    </span>

    <span class="text-webbtree-green pointer f-12 font-weight-500" (click)="openHistoryModal()"
      *ngIf="searchToolboxHistory?.length > 0">
      View All
    </span>
  </div>
  <hr class="mt-3 mb-0" style="border-top: 1px solid rgba(0, 0, 0, 0.1);" *ngIf="calledFrom != 'mainscreen' && searchToolboxHistory?.length > 0">
<div *ngIf="((!save && calledForSaveSearch != 'saveSearch') || calledForSaveSearch =='history')">
  <div *ngFor="let history of searchToolboxHistory?.slice(0,5); index as i" class="row mx-0 mb-3px py-2"
    [ngClass]="{'pt-0 pb-2 mb-2':calledFrom == 'mainscreen', 'py-2':calledFrom != 'mainscreen', 'border-bottom-gray':searchToolboxHistory?.length > 0}">
    <div class="col bb-3px">
      <div class="row">
        <div class="col d-flex justify-content-between mb-0 px-0">

          <div class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
            data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseExample' + i"
            aria-expanded="false" aria-controls="collapseExample"
            [ngClass]="{'showdhidearrow':!history.booleanquery}">

            <div class="d-grid">
              <span class="f-12 font-weight-500 text-black mb-1 text-capitalize text-truncate"
                (click)="searchFromHistory(history)" style="margin-right: 50px;">
                <span class="line-clamp" [matTooltip]="history?.title"
                  [matTooltipClass]="{ 'big-tooltip text-black text-capitalize': true }"
                  matTooltipPosition="above">{{history?.title}}</span>
              </span>
              <span style="font-size: 12px; font-weight: 400;" class="text-9696">
                {{formatDate(history?.updatedon)}}
              </span>
            </div>

            <div>
              <p style="color: #2e93a1;" (click)="searchFromHistory(history)">
                <i class="fa-regular fa-search"></i>
              </p>
            </div>

            <div *ngIf="history.booleanquery">
              <div class="col d-flex justify-content-between">
                <p class="f-10 text-9696 mr-2 mt-1 mb-0">{{formatDate(history?.updatedon)}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>



  <div *ngIf="save || calledForSaveSearch == 'saveSearch'">
    <div *ngFor="let history of searchToolboxHistory?.slice(0,5); index as i" class="row mx-0 mb-3px pb-2 mb-2"
   [ngClass]="{'border-bottom-gray':searchToolboxHistory?.length > 0}">
    <div class="col bb-3px">
      <div class="row">
        <div class="col d-flex justify-content-between mb-0 px-0">
          <div class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100 onHover"
            data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseExample' + i" aria-expanded="false"
            aria-controls="collapseExample" [ngClass]="{'showdhidearrow':!history.booleanquery}">
            <div class="d-grid"  style="max-width: 293px;" (click)="$event.preventDefault()">


              <div class="f-12 font-weight-500 text-black mb-0 text-truncate" (click)="searchFromHistory(history)">
                <span [matTooltip]="history?.talentdiscoveryname" [matTooltipClass]="{ 'big-tooltip': true }" matTooltipPosition="above" class="d-block text-truncate whitespace-pre mb-1">{{history?.talentdiscoveryname || '-'}}</span>
                <div class="d-flex">
                  <span style="font-size: 12px; font-weight: 400;" class="text-9696">{{formatDate(history?.updatedon)}}</span>
                  <span style="font-size: 12px; font-weight: 400;" class="text-9696" *ngIf="history?.issharedsearch ">&nbsp;|&nbsp;<span>Shared by {{history?.sharedby}}</span></span>
                </div>
              </div>
            </div>

            <div class="d-inline-flex">
              <div class="onhverEdit">
                <span *ngIf="members?.length && !history?.issharedsearch " (click)="openSaveSearchShareModal(history)" class="mr-2" title="Share">
                  <i class="text-bluex pointer fa-regular fa-share-nodes"></i>
                </span>
              <span *ngIf="currentUserId == history?.savedby" (click)="editSavedSearch(history)" class="mr-2" title="Edit">
                <i class="text-bluex pointer far fa-edit"></i>
              </span>
              <span *ngIf="currentUserId == history?.savedby" (click)="triggerDeleteSaveModal(history)" class="mr-2" title="Delete">
                <i class="text-bluex pointer far fa-trash"></i>
              </span>
            </div>
              <p style="color: #2e93a1;" (click)="searchFromHistory(history)"><i class="fa-regular fa-search"></i></p>
            </div>
            <div *ngIf="history.booleanquery">
              <div class="col d-flex justify-content-between">
                <p class="f-10 text-9696 mr-2 mt-1 mb-0">{{formatDate(history?.updatedon)}}</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div class="wccard empty-loader" *ngIf="searchHistoryLoader">
    <img style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader">
  </div>

  <div *ngIf="searchToolboxHistory?.length == 0 && !searchHistoryLoader" class="wccard">
    <div class="emptyScreen d-flex align-items-center justify-content-center" [ngStyle]="{'height': save ? '300px' : null }">
      <div class="createFirstTalenpool">
        <div class="text-center">
          <div class="text-center mb-3">
            <img src="../../../assets/images/search-engine-1.png" style="width: 150px;" alt="" srcset="">
          </div>
          <p *ngIf="!save" class="f-12 font-weight-500 text-center mb-5">You haven't initiated a search yet.<br> Start the search to add it to your search history.</p>
          <p *ngIf="save" class="f-12 font-weight-500 text-center mb-5">You haven't saved a search yet.<br> Save the search to add it to your saved searches.</p>
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="modal-content" *ngIf="openModal">
    <div class="modal-header hire-modal-header w-100">
      <div class="d-flex justify-content-between text-defualt w-100">
        <div>
          <span class="font-weight-600" *ngIf="!save">
             <i class="far fa-clock mr-1"></i> Search History
          </span>

          <span class="f-12 font-weight-600" *ngIf="save">
            <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
          </span>

        </div>

        <span class="f-14 font-weight-600 pointer">
          <span><i class="far fa-times f-14" (click)="modalService.dismissAll()"> </i></span>
        </span>
      </div>
    </div>

    <div class="modal-body px-3 pb-6 pt-3">
      <!-- <div class="d-flex justify-content-between mb-1 pb-2" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
        <div>
          <span class="font-weight-600" *ngIf="!save">
             <i class="far fa-clock mr-1"></i> Search History
          </span>

          <span class="f-12 font-weight-600" *ngIf="save">
            <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
          </span>

        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
        </span>
      </div> -->
      <div class="scroll-widget teste" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        [scrollWindow]="false" (scrolled)="gethistory('pagination')">
        <div *ngIf="!searchHistoryLoader && searchToolboxHistory?.length > 0">
                  <div *ngFor="let history of searchToolboxHistory; index as i" class="row mx-0 mb-3px py-2 "
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin-right: 10px !important;">
        <div class="col bb-3px">
          <div class="row">
            <div class="col d-flex justify-content-between mb-0 px-0">
              <a data-testid="auto-app-search-history-a-1" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                data-bs-toggle="collapse" href="#collapseExample{{i}}" role="button" aria-expanded="false"
                aria-controls="collapseExample" [ngClass]="{'showdhidearrow':!history.booleanquery}">
                <div class="">

                  <div class="f-12 font-weight-500 text-black mb-1 text-truncate" style="width:550px" (click)="searchFromHistory(history)">
                    <span *ngIf="!save" class="line-clamp" [matTooltip]="history?.title" [matTooltipClass]="{ 'hire-tooltip text-black': true }" matTooltipPosition="above">{{history?.title}}</span>
                    <span class="" *ngIf="!save"></span>
                    <span *ngIf="save" class="line-clamp" [matTooltip]="history?.talentdiscoveryname" [matTooltipClass]="{ 'big-tooltip': true }" matTooltipPosition="above" class="text-truncate whitespace-pre mb-1">{{history?.talentdiscoveryname || '-'}}</span>

                  </div>
                  <div class="d-flex">
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696">{{formatDate(history?.updatedon)}}</span>
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696" *ngIf="history?.issharedsearch ">&nbsp;|&nbsp;<span>Shared by {{history?.sharedby}}</span></span>
                    </div>
                </div>

                <div class="d-inline-flex">
                  <span *ngIf="members?.length && !history?.issharedsearch && save" (click)="openSaveSearchShareModal(history)" class="mr-2" title="Share">
                    <i class="text-bluex pointer fa-regular fa-share-nodes"></i>
                  </span>

                  <span *ngIf="currentUserId == history?.savedby && save" (click)="editSavedSearch(history)" class="mr-2" title="Edit">
                    <i class="text-bluex pointer far fa-edit"></i>
                  </span>
                  <span *ngIf="currentUserId == history?.savedby && save" (click)="triggerDeleteSaveModal(history)" class="mr-2" title="Delete">
                    <i class="text-bluex pointer far fa-trash"></i>
                  </span>
                  <p style="color: #2e93a1;" (click)="searchFromHistory(history)"><i class="fa-regular fa-search"></i></p>
                </div>
                <div *ngIf="history.booleanquery">
                  <div class="col d-flex justify-content-between">
                    <p class="f-10 text-9696 mr-2 mt-1 mb-0">{{formatDate(history?.updatedon)}}</p>

                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        </div>
        </div>
            <div *ngIf="searchToolboxHistory?.length == 0 && !searchHistoryLoader" class="wccard">
    <div class="emptyScreen d-flex align-items-center justify-content-center" [ngStyle]="{'height': save ? '300px' : null }">
      <div class="createFirstTalenpool">
        <div class="text-center">
          <div class="text-center mb-3">
            <img src="../../../assets/images/search-engine-1.png" style="width: 150px;" alt="" srcset="">
          </div>
          <p *ngIf="!save" class="f-12 font-weight-500 text-center mb-5">You haven't initiated a search yet.<br> Start the search to add it to your search history.</p>
          <p *ngIf="save" class="f-12 font-weight-500 text-center mb-5">You haven't saved a search yet.<br> Save the search to add it to your saved searches.</p>
        </div>
      </div>
    </div>
  </div>

         <div class="skeleton-page mb-2 px-0 pt-3" *ngIf="searchHistoryLoader">
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
          </div>

      </div>

    </div>
  </div>


<ng-template #historymodal class="modal">
  <div class="modal-content">
    <div class="modal-body px-3 pb-6 pt-3">
      <div class="d-flex justify-content-between mb-1 pb-2" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
        <div>
          <span class="font-weight-600" *ngIf="!save">
             <i class="far fa-clock mr-1"></i> Search History
          </span>

          <span class="f-12 font-weight-600" *ngIf="save">
            <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
          </span>

        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
        </span>
      </div>
      <div class="scroll-widget" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        [scrollWindow]="false" (scrolled)="gethistory('pagination')">
        <div *ngFor="let history of searchToolboxHistory; index as i" class="row mx-0 mb-3px py-2 "
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin-right: 10px !important;">
        <div class="col bb-3px">
          <div class="row">
            <div class="col d-flex justify-content-between mb-0 px-0">
              <a data-testid="auto-app-search-history-a-2" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                data-bs-toggle="collapse" href="#collapseExample{{i}}" role="button" aria-expanded="false"
                aria-controls="collapseExample" [ngClass]="{'showdhidearrow':!history.booleanquery}">
                <div class="">

                  <div class="f-12 font-weight-500 text-black mb-1 text-truncate" style="width:550px" (click)="searchFromHistory(history)">
                    <span *ngIf="!save" class="line-clamp" [matTooltip]="history?.title" [matTooltipClass]="{ 'big-tooltip text-black': true }" matTooltipPosition="above">{{history?.title}}</span>
                    <span class="" *ngIf="!save"></span>
                    <span *ngIf="save" class="line-clamp" [matTooltip]="history?.talentdiscoveryname" [matTooltipClass]="{ 'big-tooltip': true }" matTooltipPosition="above" class="text-truncate whitespace-pre mb-1">{{history?.talentdiscoveryname || '-'}}</span>

                  </div>
                  <div class="d-flex">
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696">{{formatDate(history?.updatedon)}}</span>
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696" *ngIf="history?.issharedsearch ">&nbsp;|&nbsp;<span>Shared by {{history?.sharedby}}</span></span>
                    </div>
                </div>

                <div class="d-inline-flex">
                  <span *ngIf="members?.length && !history?.issharedsearch && save" (click)="openSaveSearchShareModal(history)" class="mr-2" title="Share">
                    <i class="text-bluex pointer fa-regular fa-share-nodes"></i>
                  </span>

                  <span *ngIf="currentUserId == history?.savedby && save" (click)="editSavedSearch(history)" class="mr-2" title="Edit">
                    <i class="text-bluex pointer far fa-edit"></i>
                  </span>
                  <span *ngIf="currentUserId == history?.savedby && save" (click)="triggerDeleteSaveModal(history)" class="mr-2" title="Delete">
                    <i class="text-bluex pointer far fa-trash"></i>
                  </span>
                  <p style="color: #2e93a1;" (click)="searchFromHistory(history)"><i class="fa-regular fa-search"></i></p>
                </div>
                <div *ngIf="history.booleanquery">
                  <div class="col d-flex justify-content-between">
                    <p class="f-10 text-9696 mr-2 mt-1 mb-0">{{formatDate(history?.updatedon)}}</p>

                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      </div>

    </div>
  </div>
</ng-template>





<ng-template #deleteSavedSearchModal class="modal">
    <div class="modal-body px-3 pb-3 pt-3">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <span class="font-weight-600">
            Delete Search
          </span>
        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="deleteModalRef?.close()"> </i>
        </span>
      </div>

      <div class="row mt-3 mb-5">
        <div class="col">
          <p class="f-12 mb-0" style="color: #484b59 !important;">Are you sure you want to delete this search?</p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-search-history-button-1" class="btn-trms-white mr-3" (click)="deleteModalRef?.close()">Cancel</button>
          <button data-testid="auto-app-search-history-button-2" class="btn-trms-small" (click)="deleteSavedSearch()">OK</button>
        </div>
      </div>
    </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
